/* eslint-disable jsx-a11y/no-onchange */
/** @jsx jsx */
import { bool, string, instanceOf } from 'prop-types'
import { jsx, Label, Flex } from 'theme-ui'
import { useField } from 'formik'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker-cssmodules.css'
import './formInputs.css'
import { HelperText } from './Common'

const DatepickerInput = ({ helperText, label, name, value, ...props }) => {
  const [field, meta, helpers] = useField({ ...props, name })

  const { setValue, setError } = helpers

  const handleDateChange = date => {
    if (!date) {
      // removes this from the values object in submit handler
      setValue(undefined)
      return setError(true)
    }
    return setValue(date)
  }

  return (
    <Flex sx={{ flexDirection: 'column', width: '100%' }}>
      <Label htmlFor={name}>{label}</Label>
      {helperText && <HelperText>{helperText}</HelperText>}
      <Flex>
        <DatePicker
          {...field}
          {...props}
          dateFormat="MM/dd/yyyy"
          selected={value}
          onChange={date => handleDateChange(date)}
          sx={{
            bg:
              meta.touched && meta.error
                ? 'inputError'
                : !meta.error && !props.disabled && meta.value
                ? 'inputSuccess'
                : props.disabled
                ? 'white'
                : 'inputBackground',
            color: props.disabled ? 'muted' : 'black',
            width: '100%',
            borderRadius: 0,
            height: 50,
            border: 'none',
            p: 2,
          }}
        />
      </Flex>
    </Flex>
  )
}

DatepickerInput.propTypes = {
  disabled: bool,
  helperText: string,
  label: string,
  name: string,
  value: instanceOf(Date),
}

export default DatepickerInput
